import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Button,
  Separator,
} from '@e2n/ui';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { faMoneyBill, faPenToSquare } from '@fortawesome/pro-regular-svg-icons';
import { Bezahlungsart } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung/Bezahlungsart';
import { Sollstunden } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung/Sollstunden';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { Zuschlaege } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung/Zuschlaege';

export function Bezahlung() {
  const { t } = useTranslation();
  const { ctx } = useAnlageassistentContext();

  return (
    <AccordionItem value="bezahlung">
      <AccordionTrigger className="flex gap-1">
        <FontAwesomeIcon icon={faMoneyBill} />
        <span className="text-neutrals-900 text-xl font-bold leading-7">
          {t('domain.mitarbeiter.create.steps.bezahlung.title')}
        </span>
      </AccordionTrigger>
      <AccordionContent>
        <div className="py-4">
          <div className="flex items-center">
            <span className="text-neutrals-900 font-bold text-base leading-6">
              {t(
                'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.title',
              )}
            </span>
            <Button
              className="ml-auto"
              variant={'icon'}
              onClick={() => ctx.navigateToSubStep('bezahlung.bezahlungsart')}>
              <FontAwesomeIcon
                icon={faPenToSquare}
                className="text-primary-blue-600"
              />
            </Button>
          </div>
          <Bezahlungsart />
        </div>
        <Separator />
        <div className="py-4">
          <div className="flex items-center">
            <span className="text-neutrals-900 font-bold text-base leading-6">
              {t('domain.mitarbeiter.create.steps.bezahlung.sollstunden.title')}
            </span>
            <Button
              className="ml-auto"
              variant={'icon'}
              onClick={() =>
                ctx.navigateToSubStep('bezahlung.arbeitszeitkonto')
              }>
              <FontAwesomeIcon
                icon={faPenToSquare}
                className="text-primary-blue-600"
              />
            </Button>
          </div>
          <Sollstunden />
        </div>
        <Separator />
        <div className="my-4">
          <div className="flex items-center">
            <span className="text-neutrals-900 font-bold text-base leading-6">
              {t('domain.mitarbeiter.create.steps.bezahlung.zuschlaege.label')}
            </span>
            <Button
              className="ml-auto"
              variant={'icon'}
              onClick={() => ctx.navigateToSubStep('bezahlung.zuschlaege')}>
              <FontAwesomeIcon
                icon={faPenToSquare}
                className="text-primary-blue-600"
              />
            </Button>
          </div>
          <Zuschlaege />
        </div>
      </AccordionContent>
    </AccordionItem>
  );
}
